import { StandardEvents } from '@shopify/events';
import { shippingCost, dispatchAt, rules } from './lonvory-shipping-core.js';
class LonvoryShipping extends HTMLElement {
 connectedCallback(){
  this.abort?.abort(); this.abort=new AbortController(); const {signal}=this.abort;
  this.config=JSON.parse(this.querySelector('[data-lv-config]').textContent);
  this.variant=this.config.variant;this.cart=this.config.cart;this.pending=false;this.added=false;this.generation=0;
  this.section=this.closest('.shopify-section');
  this.section?.addEventListener(StandardEvents.productSelect,async event=>{
   if(event.target.closest('product-card'))return;
   const generation=++this.generation;this.pending=true;this.added=false;this.render();
   try{const {detail}=await event.promise;if(!this.isConnected||generation!==this.generation)return;
    this.variant=detail?.resource??null;this.pending=false;this.render();
   }catch{if(generation===this.generation){this.variant=null;this.pending=false;this.render();}}
  },{signal});
  const onQuantity=()=>{this.added=false;this.render();};
  this.section?.addEventListener('quantity-selector:update',onQuantity,{signal});
  this.section?.addEventListener('input',event=>{if(event.target.name==='quantity')onQuantity();},{signal});
  this.section?.addEventListener('change',event=>{if(event.target.name==='quantity')onQuantity();},{signal});
  document.addEventListener(StandardEvents.cartLinesUpdate,async event=>{
   this.cart=null;this.render();
   try{const result=await event.promise;if(result?.detail?.didError!==true&&event.target.closest('product-form-component')===this.form)this.added=true;}catch{}
   await this.refreshCart();
  },{signal});
  window.addEventListener('pageshow',()=>this.refreshCart(),{signal});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.refreshCart();},{signal});
  this.timer=setInterval(()=>{if(!document.hidden)this.render();},30000);
  this.render();this.refreshCart();
 }
 disconnectedCallback(){this.abort?.abort();clearInterval(this.timer);}
 get form(){return this.section?.querySelector('product-form-component');}
 async refreshCart(){
  const generation=this.cartGeneration=(this.cartGeneration||0)+1;
  try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'},cache:'no-store',signal:this.abort.signal});if(!response.ok)throw Error();const cart=await response.json();if(generation!==this.cartGeneration)return;this.cart=cart;}catch{if(generation===this.cartGeneration)this.cart=null;}
  if(this.isConnected)this.render();
 }
 render(){
  const country=this.config.country,rule=rules[country],variant=this.variant;
  const available=Boolean(variant?.available),currency=this.cart?.currency||this.config.currency;
  const quantity=Math.max(1,Number(this.form?.querySelector('[name="quantity"]')?.value)||1);
  const title=this.querySelector('[data-lv-dispatch]'),detail=this.querySelector('[data-lv-delivery]'),cost=this.querySelector('[data-lv-cost]'),remaining=this.querySelector('[data-lv-remaining]');
  const closed=this.config.closed.split(/[\s,;]+/).filter(Boolean);
  title.textContent=this.pending?'Verfügbarkeit wird geprüft …':!variant?'Bitte eine verfügbare Variante wählen':dispatchAt(new Date(),available,closed);
  this.dataset.stock=available&&!this.pending?'yes':'no';
  detail.textContent=this.pending?'':!available?'Wähle eine verfügbare Variante.':(rule?'Lieferzeit: '+rule.delivery:'');
  cost.classList.remove('lv-free');
  const money=cents=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(cents/100);
  if(!rule||currency!=='EUR'){cost.textContent='Versandkosten im Checkout';remaining.textContent='Die verfügbaren Versandarten richten sich nach deiner Lieferadresse.';return;}
  // Never estimate an unconfirmed cart or include an unavailable/pending selection.
  if(!this.cart||!available||this.pending||!variant){cost.textContent='Versand kostenlos ab '+money(rule.threshold);remaining.textContent='Darunter '+money(rule.fee)+' nach '+rule.name;return;}
  const result=shippingCost(country,Math.round(Number(variant.price)),quantity,this.cart.total_price,!this.added);
  if(!result){cost.textContent='Versandkosten im Checkout';remaining.textContent='Alle Details findest du in den Versandbedingungen.';return;}
  if(result.remaining===0){cost.textContent='Kostenloser Versand';cost.classList.add('lv-free');remaining.textContent='';}
  else{cost.textContent=money(rule.fee)+' Versand';remaining.textContent='Noch für '+money(result.remaining)+' bestellen, dann versandkostenfrei.';}
 }
}
if(!customElements.get('lonvory-shipping'))customElements.define('lonvory-shipping',LonvoryShipping);
